import { BaseRemoteService } from '@ofqual/portal-core/core/dataAccess';
import { Model, Opts, PagedResponse } from '@ofqual/portal-core/core/types';
import { API_HOST_REFDATA } from '../config';
import { paramsToSearchString } from '@ofqual/portal-core/core/utils/urlHelper';

export class SubjectsService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${API_HOST_REFDATA}/ExpertSubject${paramsToSearchString({
      maxResults: 100000
    })}`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data.sort((a, b) => (a.subjectTitle > b.subjectTitle ? 1 : -1));
  }

  public async get(id: string, opts: Opts): Promise<Model> {
    const url = `${API_HOST_REFDATA}/ExpertSubject/${id}`;
    const data = await super.getRequest<Model>(url, opts);

    return {
     id: data.id.toString(),
     label: data.subjectTitle + " " + (data.qualificationType ? data.qualificationType : "") + " " + (data.qualificationLevel ? "(" + data.qualificationLevel + ")" : "")
     }
  }

  public async getIds(ids: number[], opts: Opts): Promise<Model[]> {
    let idString = '';
    ids.forEach((id, index) => {
      index > 0 ? (idString = idString + `&ids=${id}`) : (idString = `ids=${id}`);
    });

    const url = `${API_HOST_REFDATA}/ExpertSubject/by-ids?${idString}`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data;
  }

  public async getSubjectsByTitle(subject: string): Promise<PagedResponse<Model>> {
    const url = `${API_HOST_REFDATA}/ExpertSubject?query=${subject}&activeOnly=true`;
    const data = await super.getRequest<Model[]>(url, {});

    const mappedData = data.map((x) => ({
      id: x.id.toString(),
      label: x.subjectTitle + " " + (x.qualificationType ? x.qualificationType : "") + " " + (x.qualificationLevel ? "(" + x.qualificationLevel + ")" : "")
    }));

    let response:PagedResponse<Model> = {
      data: mappedData,
      count: mappedData.length,
      page: 0,
      pageSize: 50
    }
    return  response;
  }
}
